import { useIntl } from "react-intl";
import { ButtonWrapper } from "src/components/TripPlanner/TripCard/ShowMoreButton";
import { Button } from "src/design-system/components/Button/Button";
import type { ComponentProps } from "react";
import messages from "./SearchPromo.messages";

export function PromoViewMoreButton({
  onPress,
}: {
  onPress?: ComponentProps<typeof Button>["onPress"];
}) {
  const intl = useIntl();

  return (
    <ButtonWrapper $isSearchPromo>
      <Button variant="secondary" size="large" onPress={onPress}>
        {intl.formatMessage(messages.viewMore)}
      </Button>
    </ButtonWrapper>
  );
}
